<iframe class="voxr" [src]="url | safe"></iframe>
